import { bunja } from 'bunja';
import { createScopeFromContext } from 'bunja/react';
import { createContext } from 'react';

import { openPositionsBunja } from '@flipster/r230522/original/position';

import { createPositionByIdOrDismissAtom } from '../../utils/position-or-dismiss';

export const PnlModalContext = createContext<{ symbol: string; positionId: string } | null>(null);
export const PnlModalScope = createScopeFromContext(PnlModalContext);

export const pnlModalBunja = bunja(() => {
  const init = bunja.use(PnlModalScope);
  const { openPositionsAtom } = bunja.use(openPositionsBunja);

  const positionAtom = createPositionByIdOrDismissAtom({
    openPositionsAtom,
    symbol: init?.symbol,
    positionId: init?.positionId,
  });

  return { positionAtom };
});
pnlModalBunja.debugLabel = 'pnlModalBunja';
